import type { RouteRecordRaw } from 'vue-router'

const documentsRoutes: RouteRecordRaw[] = [
  {
    path: '/documents',
    name: 'Documents',
    component: () => import('./Documents.vue')
  }
]

export default documentsRoutes
